//import { store } from './redux/store';
// import { tagsToArray } from "./Components-Pages/JobBoard/utils";
import { City, State } from "country-state-city";
import { API } from "./API";
import { PORT } from "./config";

export const getCurrentPage = (pageNumber, itemArray, itemsPerPage = 10) => {
  let currentItems = [];
  if (itemArray.length % itemsPerPage == 0) {
    for (
      let i = (pageNumber - 1) * itemsPerPage;
      i < (pageNumber - 1) * itemsPerPage + itemsPerPage;
      i++
    ) {
      if (itemArray[i]) currentItems.push(itemArray[i]);
    }
  } else {
    for (
      let i = (pageNumber - 1) * itemsPerPage;
      i < (pageNumber - 1) * itemsPerPage + itemsPerPage;
      i++
    ) {
      if (i < itemArray.length) {
        if (itemArray[i]) currentItems.push(itemArray[i]);
      }
    }
  }

  return currentItems;
};

// todo: rework this function a bit
export const calculatePages = (itemArray, itemsPerPage = 10) => {
  let arr = [];
  if (itemArray.length != 0 && itemArray.length % itemsPerPage == 0) {
    for (let i = 1; i <= itemArray.length / itemsPerPage; i++) {
      arr.push(i);
    }
  } else if (itemArray.length == 0) {
  } else if (itemArray.length != 0 && itemArray.length % itemsPerPage != 0) {
    for (let i = 1; i <= itemArray.length / itemsPerPage + 1; i++) {
      arr.push(i);
    }
  }
  return arr;
};

const collegeCategories = [
  'ge',
  'exam',
  'academic',
  'vet',
  'other',
  'bsb',
  'chc',
  'cua',
  'fns',
  'fsk',
  'shb',
  'hlt',
  'ict',
  'cpp',
  'sis',
  'sit',
  'tae',
  'vet_other',
];

export const getClassCategories = (isCollege = false) => {
  let categories = [
    { value: 'ge', name: 'General English', type: 'eng' },
    { value: 'exam', name: 'Exam/Assessment-related', type: 'eng' },
    { value: 'manage', name: 'Management', type: 'eng' },
    { value: 'online', name: 'Online Classrooms', type: 'eng' },
    { value: 'tt', name: 'Teacher Training', type: 'eng' },
    { value: 'academic', name: 'Academic Programs', type: 'eng' },
    // { value: "tech", name: "Technology/Applications" },
    { value: 'lms', name: 'Learning Management Systems (LMS)', type: 'eng' },
    { value: 'vet', name: 'VET English', type: 'eng' },
    { value: 'ld', name: 'Learning Design', type: 'eng' },
    // { value: "other", name: "Other English", type: "eng" },

    { value: 'bsb', name: 'Business Services', type: 'vet' },
    { value: 'chc', name: 'Community Services', type: 'vet' },
    { value: 'cua', name: 'Creative Arts and Culture', type: 'vet' },
    { value: 'fns', name: 'Financial Services', type: 'vet' },
    { value: 'fsk', name: 'Foundation Skills', type: 'vet' },
    { value: 'shb', name: 'Hairdressing and Beauty Services', type: 'vet' },
    { value: 'hlt', name: 'Health', type: 'vet' },
    {
      value: 'ict',
      name: 'Information and Communications Technology/ Digital Jobs Training',
      type: 'vet',
    },
    { value: 'cpp', name: 'Property Services', type: 'vet' },
    { value: 'sis', name: 'Sport, Fitness and Recreation', type: 'vet' },
    { value: 'sit', name: 'Tourism, Travel and Hospitality', type: 'vet' },
    { value: 'tae', name: 'Training and Education', type: 'vet' },
    { value: 'vet_other', name: 'Other VET', type: 'vet' },
  ];

  if (isCollege) {
    categories = categories.filter((cat) =>
      collegeCategories.includes(cat.value)
    );
  }

  return categories;
};

export const teacherStatus = {
  not_assigned: 'unassigned',
  assigned: 'assigned',
  responded: 'responded',
  none_available: 'none available',
};

export const teacherResponse = {
  not_responded: 'unresponded',
  accepted: 'accepted',
  rejected: 'rejected',
  cancelled: 'cancelled',
  rdo: 'RDO',
};

export const getClass = (isCollege = false) => {
  let classes = [
    { 
      key: 'First Nations Learners', 
      whole_name: 'First Nations Learners', 
      short_name: 'First Nations Learners', 
      type: ['cua'], tags: []
    },
    { 
      key: 'First Nations Leadership', 
      whole_name: 'First Nations Leadership', 
      short_name: 'First Nations Leadership', 
      type: ['cua'], tags: []
    },
    { 
      key: 'First Nations Cross-Cultural Awareness', 
      whole_name: 'First Nations Cross-Cultural Awareness', 
      short_name: 'First Nations Cross-Cultural Awareness', 
      type: ['cua'], tags: [] 
    },
    { 
      key: 'Aboriginal Cultural Awareness', 
      whole_name: 'Aboriginal Cultural Awareness', 
      short_name: 'Aboriginal Cultural Awareness', 
      type: ['cua'], tags: [] 
    },
    {
      key: 'Teacher Briefing',
      whole_name: 'Teacher Briefing',
      short_name: 'Teacher Briefing',
      type: ['eng'],
      tags: [],
    },
    {
      key: 'Data Analytics',
      whole_name: 'Data Analytics',
      short_name: 'Data Analytics',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'Programming and Software Development',
      whole_name: 'Programming and Software Development',
      short_name: 'Programming',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'Cyber Security',
      whole_name: 'Cyber Security',
      short_name: 'Cyber Security',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'Cloud Computing',
      whole_name: 'Cloud Computing',
      short_name: 'Cloud Computing',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'AI and Machine Learning',
      whole_name: 'AI and Machine Learning',
      short_name: 'AI & ML',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'Project Management',
      whole_name: 'Project Management',
      short_name: 'Project Management',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'Digital Marketing, Operations and Support',
      whole_name: 'Digital Marketing, Operations and Support',
      short_name: 'Digital Marketing',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'Web Development',
      whole_name: 'Web Development',
      short_name: 'Web Development',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'Product Management',
      whole_name: 'Product Management',
      short_name: 'Product Management',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'UX and UI',
      whole_name: 'UX and UI',
      short_name: 'UX and UI',
      type: ['ict'],
      tags: [],
    },{
      key: 'Social Media/Digital Marketing',
      whole_name: 'Social Media/Digital Marketing',
      short_name: 'Social Media/Digital Marketing',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'Teamwork and Collaboration',
      whole_name: 'Teamwork and Collaboration',
      short_name: 'Teamwork',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'All ELICOS',
      // whole_name: `All Australia's English Language Intensive Courses for Overseas Students - General English`,
      whole_name: 'All Levels',
      // short_name field is never actually used, and therefore, we will use "" for new courses
      short_name: '/',
      type: ['ge'],
      tags: [],
    },
    {
      key: 'Beginner/Starter',
      whole_name: 'Beginner/Starter',
      short_name: 'Begin',
      type: ['ge'],
      tags: [],
    },
    {
      key: 'Elementary GE',
      whole_name: 'Elementary',
      short_name: 'Elem',
      type: ['ge'],
      tags: [],
    },
    {
      key: 'Pre-Intermediate GE',
      whole_name: 'Pre-Intermediate',
      short_name: 'P-int',
      type: ['ge'],
      tags: [],
    },
    {
      key: 'Intermediate GE',
      whole_name: 'Intermediate',
      short_name: 'Inter',
      type: ['ge'],
      tags: [],
    },
    {
      key: 'Upper-Intermediate GE',
      whole_name: 'Upper-Intermediate',
      short_name: 'U-int',
      type: ['ge'],
      tags: [],
    },
    {
      key: 'Advanced GE',
      whole_name: 'Advanced',
      short_name: 'Adv',
      type: ['ge'],
      tags: [],
    },
    {
      key: 'Proficiency',
      whole_name: 'Proficiency',
      short_name: 'Prof',
      type: ['ge'],
      tags: [],
    },
    {
      key: 'Blended Lower GE',
      whole_name: 'Blended Lower',
      short_name: 'Lower',
      type: ['ge'],
      tags: [],
    },
    {
      key: 'Blended Upper GE',
      whole_name: 'Blended Upper',
      short_name: 'Upper',
      type: ['ge'],
      tags: [],
    },

    {
      key: 'Young Learners',
      whole_name: 'Young Learners',
      short_name: 'YLs',
      type: ['ge'],
      tags: [],
    },
    {
      key: 'Teens',
      whole_name: 'Teens',
      short_name: 'Teens',
      type: ['ge'],
      tags: [],
    },
    {
      key: 'Cambridge CPE',
      whole_name: 'Cambridge Proficiency (CPE)',
      short_name: 'CPE',
      type: ['exam'],
      tags: [],
    },
    {
      key: 'Cambridge KEY',
      whole_name: 'Cambridge Key (KEY)',
      short_name: 'KEY',
      type: ['exam'],
      tags: [],
    },
    {
      key: 'Cambridge PET',
      whole_name: 'Cambridge Preliminary (PET)',
      short_name: 'PET',
      type: ['exam'],
      tags: [],
    },
    {
      key: 'Cambridge FCE',
      whole_name: 'Cambridge First (FCE)',
      short_name: 'FCE',
      type: ['exam'],
      tags: [],
    },
    {
      key: 'Cambridge CAE',
      whole_name: 'Cambridge Advanced (CAE)',
      short_name: 'CAE',
      type: ['exam'],
      tags: [],
    },
    {
      key: 'PTE',
      whole_name: 'Pearson PTE',
      short_name: 'PTE',
      type: ['exam'],
      tags: [],
    },
    {
      key: 'IELTS',
      // whole_name: "International English Language Testing System",
      whole_name: 'Cambridge IELTS',
      short_name: 'IELTS',
      type: ['exam'],
      tags: [],
    },
    // {
    //   key: "IELTS Intermediate",
    //   whole_name:
    //     "Intermediate - International English Language Testing System",
    //   short_name: "IELTS INT",
    //   type: ["cam"],
    //   tags: []
    // },
    {
      key: 'IELTS Advanced',
      // whole_name: "Advanced - International English Language Testing System",
      whole_name: 'Cambridge IELTS Advanced',
      short_name: 'IELTS',
      type: ['exam'],
      tags: [],
    },
    {
      key: 'Occupational English Test',
      whole_name: 'Occupational English Test (OET)',
      short_name: 'OET',
      type: ['exam'],
      tags: [],
    },
    {
      key: 'Academic Manager',
      whole_name: 'Academic Manager',
      short_name: 'Man',
      type: ['manage'],
      tags: [],
    },
    {
      key: 'Assistant Academic Manager',
      whole_name: 'Assistant Academic Manager',
      short_name: 'Man',
      type: ['manage'],
      tags: [],
    },
    {
      key: 'Program or Department Director',
      whole_name: 'Director: Program or Department',
      short_name: 'Man',
      type: ['manage'],
      tags: [],
    },
    {
      key: 'Student Support Officer',
      whole_name: 'Student Support Officer',
      short_name: 'Supp',
      type: ['manage'],
      tags: [],
    },
    {
      key: 'Program Coordinator',
      whole_name: 'Program Coordinator',
      short_name: 'Program Coordinator',
      type: ['manage'],
      tags: [],
    },
    {
      key: 'Curriculum Design',
      whole_name: 'Curriculum Design & Development',
      short_name: 'Curriculum Design & Development',
      type: ['ld'],
      tags: [],
      tt_hide: true,
    },
    {
      key: 'Business English',
      whole_name: 'Business English',
      short_name: 'BusE',
      type: ['ge'],
      tags: [],
    },
    {
      key: 'Study Tours',
      whole_name: 'Study Tours',
      short_name: 'Study',
      type: ['ge'],
      tags: [],
    },
    {
      key: 'English Camps',
      whole_name: 'English Camps',
      short_name: 'English Camps',
      type: ['ge'],
      tags: [],
    },
    {
      key: 'English for Academic Purposes',
      whole_name: 'English for Academic Purposes (EAP)',
      short_name: 'EAP',
      type: ['ge'],
      tags: [],
    },
    // {
    //   key: "Social Program Officer",
    //   whole_name: "Student Program Officer",
    //   short_name: "Student Program Officer",
    //   type: ["manage"],
    //   tags: []
    // },
    {
      key: 'Zoom',
      whole_name: 'Zoom',
      short_name: 'Zoom',
      type: ['online'],
      tags: [],
    },
    {
      key: 'Skype',
      whole_name: 'Skype',
      short_name: 'Skype',
      type: ['online'],
      tags: [],
    },
    {
      key: 'Microsoft Teams',
      whole_name: 'Microsoft Teams',
      short_name: 'Teams',
      type: ['online'],
      tags: [],
    },
    {
      key: 'Whereby',
      whole_name: 'Whereby',
      short_name: 'Whereby',
      type: ['online'],
      tags: [],
    },
    {
      key: 'Bb Collaborate Ultra',
      whole_name: 'Blackboard Collaborate',
      short_name: 'Colab',
      type: ['online'],
      tags: [],
    },
    {
      key: 'Google Meet',
      whole_name: 'Google Meet',
      short_name: 'Meet',
      type: ['online'],
      tags: [],
    },
    {
      key: 'Teaching Young Learners',
      whole_name: 'Teaching Young Learners',
      short_name: 'Teaching Young Learners',
      type: ['tt'],
      tags: [],
    },
    {
      key: 'Teaching Teens',
      whole_name: 'Teaching Teens',
      short_name: 'Teaching Teens',
      type: ['tt'],
      tags: [],
    },
    {
      key: 'Teaching Adults',
      whole_name: 'Teaching Adults',
      short_name: 'Teaching Adults',
      type: ['tt'],
      tags: [],
    },
    {
      key: 'Teaching EAP',
      whole_name: 'Teaching EAP',
      short_name: 'Teaching EAP',
      type: ['tt'],
      tags: [],
    },
    {
      key: 'Classroom Management',
      whole_name: 'Classroom Management',
      short_name: 'Classroom Management',
      type: ['tt'],
      tags: [],
    },
    {
      key: 'Motivating Students',
      whole_name: 'Motivating Students',
      short_name: 'Motivating Students',
      type: ['tt'],
      tags: [],
    },
    {
      key: 'Teaching With Technology',
      whole_name: 'Teaching With Technology',
      short_name: 'Teaching With Technology',
      type: ['tt'],
      tags: [],
    },
    {
      key: 'Academic English',
      whole_name: 'Academic English (EAP)',
      short_name: 'EAP',
      type: ['academic'],
      tags: [],
    },
    {
      key: 'University Prep/Bridging',
      whole_name: 'University Prep/Bridging',
      short_name: 'Prep',
      type: ['academic'],
      tags: [],
    },
    {
      key: 'Lecturer - English',
      whole_name: 'Lecturer - English Language',
      short_name: 'Lecturer - English',
      type: ['academic'],
      tags: [],
      tt_hide: true,
    },
    {
      key: 'Lecturer - Other',
      whole_name: 'Lecturer - Other than English',
      short_name: 'Lecturer - Other',
      type: ['academic'],
      tags: [],
      tt_hide: true,
    },
    {
      key: 'Moodle',
      whole_name: 'Moodle',
      short_name: 'MoodL',
      type: ['lms'],
      tags: [],
    },
    {
      key: 'Blackboard',
      whole_name: 'Blackboard',
      short_name: 'Blackboard',
      type: ['lms'],
      tags: [],
    },
    {
      key: 'Canvas LMS',
      whole_name: 'Canvas',
      short_name: 'Canvs',
      type: ['lms'],
      tags: [],
    },
    {
      key: 'Catapult',
      whole_name: 'Catapult',
      short_name: 'Catapult',
      type: ['lms'],
      tags: [],
    },
    {
      key: 'STARS',
      whole_name: 'STARS',
      short_name: 'STARS',
      type: ['lms'],
      tags: [],
    },
    {
      key: 'Google Classroom',
      whole_name: 'Google Classroom',
      short_name: 'Google Classroom',
      type: ['lms'],
      tags: [],
    },
    // {
    //   key: "Padlet",
    //   whole_name: "Padlet",
    //   short_name: "Padlet",
    //   type: ["tech"],
    //   tags: []
    // },
    {
      key: 'CIEAL',
      whole_name: 'Course in Initial English as an Additional Language (CIEAL)',
      short_name: 'CIEAL',
      type: ['vet'],
      tags: [],
    },
    {
      key: 'CEAL',
      whole_name: 'Course in English as an Additional Language (CEAL)',
      short_name: 'CEAL',
      type: ['vet'],
      tags: [],
    },
    {
      key: 'EAL1',
      whole_name: 'Blended CEAL (EAL1)',
      short_name: 'EAL1',
      type: ['vet'],
      tags: [],
    },
    {
      key: 'EAL I',
      whole_name: 'Certificate I in English as an Additional Language (EAL I)',
      short_name: 'EAL I',
      type: ['vet'],
      tags: [],
    },
    {
      key: 'EAL II',
      whole_name:
        'Certificate II in English as an Additional Language (EAL II)',
      short_name: 'EAL II',
      type: ['vet'],
      tags: [],
    },
    {
      key: 'EAL III',
      whole_name:
        'Certificate III in English as an Additional Language (EAL III)',
      short_name: 'EAL III',
      type: ['vet'],
      tags: [],
    },
    {
      key: 'EAL IV',
      whole_name:
        'Certificate IV in English as an Additional Language (EAL IV)',
      short_name: 'EAL IV',
      type: ['vet'],
      tags: [],
    },
    {
      key: 'CSWE I',
      whole_name: 'Certificate I in Spoken & Written English (CSWE I)',
      short_name: 'CSWE I',
      type: ['vet'],
      tags: [],
    },
    {
      key: 'CSWE II',
      whole_name: 'Certificate II in Spoken & Written English (CSWE II)',
      short_name: 'CSWE II',
      type: ['vet'],
      tags: [],
    },
    {
      key: 'CSWE III',
      whole_name: 'Certificate III in Spoken & Written English (CSWE III)',
      short_name: 'CSWE III',
      type: ['vet'],
      tags: [],
    },
    {
      key: 'CSWE IV',
      whole_name: 'Certificate IV in Spoken & Written English (CSWE IV)',
      short_name: 'CSWE IV',
      type: ['vet'],
      tags: [],
    },

    {
      key: 'Curriculum Designer',
      whole_name: 'Curriculum Designer',
      short_name: 'Curriculum Designer',
      type: ['exp-vet'],
      tags: [],
      tt_hide: true,
    },

    {
      key: 'Curriculum Writer',
      whole_name: 'Curriculum Writer',
      short_name: 'Curriculum Writer',
      type: ['exp-vet'],
      tags: [],
      tt_hide: true,
    },

    {
      key: 'Moderator/Auditor',
      whole_name: 'Moderator/Auditor',
      short_name: 'Moderator/Auditor',
      type: ['exp-vet'],
      tags: [],
      tt_hide: true,
    },

    // {
    //   key: "Academic Manager",
    //   whole_name: "Academic Manager",
    //   short_name: "Academic Manager",
    //   type: ["exp-vet"],
    //   tags: [],
    //   tt_hide: true
    // },

    // {
    //   key: "Assistant Academic Manager",
    //   whole_name: "Assistant Academic Manager",
    //   short_name: "Assistant Academic Manager",
    //   type: ["exp-vet"],
    //   tags: [],
    //   tt_hide: true
    // },

    {
      key: 'Campus Manager',
      whole_name: 'Campus Manager',
      short_name: 'Campus Manager',
      type: ['exp-vet'],
      tags: [],
      tt_hide: true,
    },

    {
      key: 'Director: Program or Department',
      whole_name: 'Director: Program or Department',
      short_name: 'Director: Program or Department',
      type: ['exp-vet'],
      tags: [],
      tt_hide: true,
    },

    {
      key: 'Work Placement Coordinator',
      whole_name: 'Work Placement Coordinator',
      short_name: 'Work Placement Coordinator',
      type: ['exp-vet'],
      tags: [],
      tt_hide: true,
    },

    {
      key: 'Learning Designer',
      whole_name: 'Learning Designer',
      short_name: 'Learning Designer',
      type: ['ld'],
      tags: [],
    },

    {
      key: 'Learning Technologist',
      whole_name: 'Learning Technologist',
      short_name: 'Learning Technologist',
      type: ['ld'],
      tags: [],
    },

    {
      key: 'Exam Item Writer',
      whole_name: 'Exam Item Writer',
      short_name: 'Exam Item Writer',
      type: ['exam'],
      tags: [],
      tt_hide: true,
    },

    {
      key: 'Examiner - IELTS',
      whole_name: 'Examiner - IELTS',
      short_name: 'Examiner - IELTS',
      type: ['exam'],
      tags: [],
      tt_hide: true,
    },

    {
      key: 'Examiner - OET',
      whole_name: 'Examiner - OET',
      short_name: 'Examiner - OET',
      type: ['exam'],
      tags: [],
      tt_hide: true,
    },

    {
      key: 'Examiner - PTE',
      whole_name: 'Examiner - PTE',
      short_name: 'Examiner - PTE',
      type: ['exam'],
      tags: [],
      tt_hide: true,
    },

    {
      key: 'Special Projects Team',
      whole_name: 'Special Projects Team',
      short_name: 'Special Projects Team',
      type: ['ge'],
      tags: [],
      tt_hide: true,
    },

    {
      key: 'AMEP',
      whole_name: 'Adult Migrant English Program (AMEP)',
      short_name: 'AMEP',
      type: ['vet'],
      tags: [],
    },

    {
      key: 'SEE',
      whole_name: 'Skills for Education & Employment (SEE)',
      short_name: 'SEE',
      type: ['vet'],
      tags: [],
    },
    {
      key: 'Didasko',
      whole_name: 'Didasko',
      short_name: 'Didasko',
      type: ['lms'],
      tags: [],
    },

    {
      key: 'Offshore Delivery Programs',
      whole_name: 'Offshore Delivery Programs',
      short_name: 'Offshore Delivery Programs',
      type: ['ge'],
      tags: [],
    },

    // VET courses

    {
      key: 'bsb10120',
      whole_name: 'Workplace Skills - Cert. I (10120)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb20120',
      whole_name: 'Workplace Skills - Cert. II (20120)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb30120',
      whole_name: 'Business - Cert. III (30120)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb30220',
      whole_name: 'Entrepreneurship and New Business - Cert. III (30220)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb40120',
      whole_name: 'Business - Cert. IV (40120)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb40320',
      whole_name: 'Entrepreneurship and New Business - Cert. IV (40320)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb40420',
      whole_name: 'Human Resource Management - Cert. IV (40420)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb40520',
      whole_name: 'Leadership and Management - Cert. IV (40520)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb40820',
      whole_name: 'Marketing and Communication - Cert. IV (40820)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb40920',
      whole_name: 'Project Management and Practice - Cert. IV (40920)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb50120',
      whole_name: 'Business - Diploma (50120)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb50320',
      whole_name: 'Human Resource Management - Diploma (50320)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb50420',
      whole_name: 'Leadership and Management - Diploma (50420)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb50620',
      whole_name: 'Marketing and Communication - Diploma (50620)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb50820',
      whole_name: 'Project Management - Diploma (50820)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb60120',
      whole_name: 'Business - Adv. Diploma (60120)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb60320',
      whole_name: 'Human Resource Management - Adv. Diploma (60320)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb60420',
      whole_name: 'Leadership and Management - Adv. Diploma (60420)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb60520',
      whole_name: 'Marketing and Communication - Adv. Diploma (60520)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'bsb60720',
      whole_name: 'Program Management - Adv. Diploma (60720)',
      short_name: '',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'mss40118',
      whole_name: 'Sustainable Operations - Cert. IV (MSS40118)',
      short_name: 'Sustainable Operations',
      type: ['bsb'],
      tags: [],
    },
    {
      key: 'chc22015',
      whole_name: 'Community Services - Cert. II (22015)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc30113',
      whole_name: 'Early Childhood Education and Care - Cert. III (30113)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc30213',
      whole_name: 'Education Support - Cert. III (30213)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc32015',
      whole_name: 'Community Services - Cert. III (32015)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc33015',
      whole_name: 'Individual Support - Cert. III (33015)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc40113',
      whole_name: 'School Age Education and Care - Cert. IV (40113)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc40213',
      whole_name: 'Education Support - Cert. IV (40213)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc40313',
      whole_name: 'Child, Youth and Family Intervention - Cert. IV (40313)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc40413',
      whole_name: 'Youth Work - Cert. IV (40413)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc42015',
      whole_name: 'Community Services - Cert. IV (42015)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc42115',
      whole_name: 'Community Development - Cert. IV (42115)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc43015',
      whole_name: 'Ageing Support - Cert. IV (43015)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc43115',
      whole_name: 'Disability - Cert. IV (43115)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc50113',
      whole_name: 'Early Childhood Education and Care - Diploma (50113)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc50413',
      whole_name: 'Youth Work - Diploma (50413)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc52015',
      whole_name: 'Community Services - Diploma (52015)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc52015-2',
      whole_name: 'Community Services (Case Management) - Diploma (52015)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc52115',
      whole_name: 'Community Development - Diploma (52115)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc43215',
      whole_name: 'Alcohol and Other Drugs - Cert. IV (43215)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc43315',
      whole_name: 'Mental Health - Cert. IV (43315)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc43515',
      whole_name: 'Mental Health Peer Work - Cert. IV (43515)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc53215',
      whole_name: 'Alcohol and Other Drugs - Diploma (53215)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'chc53315',
      whole_name: 'Mental Health - Diploma (53315)',
      short_name: '',
      type: ['chc'],
      tags: [],
    },
    {
      key: 'fns20120',
      whole_name: 'Financial Services - Cert. II (20120)',
      short_name: '',
      type: ['fns'],
      tags: [],
    },
    {
      key: 'fns30120',
      whole_name: 'Financial Services - Cert. III (30120)',
      short_name: '',
      type: ['fns'],
      tags: [],
    },
    {
      key: 'fns30317',
      whole_name: 'Accounts Administration - Cert. III (30317)',
      short_name: '',
      type: ['fns'],
      tags: [],
    },
    {
      key: 'fns40217',
      whole_name: 'Accounting and Bookkeeping - Cert. IV (40217)',
      short_name: '',
      type: ['fns'],
      tags: [],
    },
    {
      key: 'fns41820',
      whole_name: 'Financial Services - Cert. I (41820)',
      short_name: '',
      type: ['fns'],
      tags: [],
    },
    {
      key: 'fns50217',
      whole_name: 'Accounting - Diploma (50217)',
      short_name: '',
      type: ['fns'],
      tags: [],
    },
    {
      key: 'fns50417',
      whole_name: 'Payroll Services - Diploma (50417)',
      short_name: '',
      type: ['fns'],
      tags: [],
    },
    {
      key: 'fns51820',
      whole_name: 'Financial Services - Diploma (51820)',
      short_name: '',
      type: ['fns'],
      tags: [],
    },
    {
      key: 'fns60217',
      whole_name: 'Accounting - Adv. Diploma (60217)',
      short_name: '',
      type: ['fns'],
      tags: [],
    },
    {
      key: 'fsk10119',
      whole_name: 'Access to Vocational Pathways - Cert. I (10119)',
      short_name: '',
      type: ['fsk'],
      tags: [],
    },
    {
      key: 'fsk10219',
      whole_name: 'Skills for Vocational Pathways - Cert. I (10219)',
      short_name: '',
      type: ['fsk'],
      tags: [],
    },
    {
      key: 'fsk20119',
      whole_name: 'Skills for Work and Vocational Pathways - Cert. II (20119)',
      short_name: '',
      type: ['fsk'],
      tags: [],
    },
    {
      key: 'shb20116',
      whole_name: 'Retail Cosmetics - Cert. II (20116)',
      short_name: '',
      type: ['shb'],
      tags: [],
    },
    {
      key: 'shb20216',
      whole_name: 'Salon Assistant - Cert. II (20216)',
      short_name: '',
      type: ['shb'],
      tags: [],
    },
    {
      key: 'shb30115',
      whole_name: 'Beauty Services - Cert. III (30115)',
      short_name: '',
      type: ['shb'],
      tags: [],
    },
    {
      key: 'shb30215',
      whole_name: 'Make-up - Cert. III (30215)',
      short_name: '',
      type: ['shb'],
      tags: [],
    },
    {
      key: 'shb30315',
      whole_name: 'Nail Technology - Cert. III (30315)',
      short_name: '',
      type: ['shb'],
      tags: [],
    },
    {
      key: 'shb30416',
      whole_name: 'Hairdressing - Cert. III (30416)',
      short_name: '',
      type: ['shb'],
      tags: [],
    },
    {
      key: 'shb30516',
      whole_name: 'Barbering - Cert. III (30516)',
      short_name: '',
      type: ['shb'],
      tags: [],
    },
    {
      key: 'shb40115',
      whole_name: 'Beauty Therapy - Cert. IV (40115)',
      short_name: '',
      type: ['shb'],
      tags: [],
    },
    {
      key: 'shb40216',
      whole_name: 'Hairdressing - Cert. IV (40216)',
      short_name: '',
      type: ['shb'],
      tags: [],
    },
    {
      key: 'shb50115',
      whole_name: 'Beauty Therapy - Diploma (50115)',
      short_name: '',
      type: ['shb'],
      tags: [],
    },
    {
      key: 'shb50216',
      whole_name: 'Salon Management - Diploma (50216)',
      short_name: '',
      type: ['shb'],
      tags: [],
    },
    {
      key: 'shb60118',
      whole_name:
        'Intense pulsed Light and Laser for Hair Reduction - Adv. Diploma (60118)',
      short_name: '',
      type: ['shb'],
      tags: [],
    },
    {
      key: 'ict20120',
      whole_name: 'Applied Digital Technologies - Cert. II (20120)',
      short_name: '',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'ict20219',
      whole_name:
        'Telecommunications Network Build and Operation - Cert. II (20219)',
      short_name: '',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'ict20319',
      whole_name: 'Telecommunications Technology - Cert. II (20319)',
      short_name: '',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'ict30120',
      whole_name: 'Information Technology - Cert. III (30120)',
      short_name: '',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'ict30419',
      whole_name:
        'Telecommunications Network Build and Operation - Cert. III (30419)',
      short_name: '',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'ict30519',
      whole_name: 'Telecommunications Technology - Cert. III (30519)',
      short_name: '',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'ict40120',
      whole_name: 'Information Technology - Cert. IV (40120)',
      short_name: '',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'ict41119',
      whole_name: 'Telecommunications Network Design - Cert. IV (41119)',
      short_name: '',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'ict41219',
      whole_name:
        'Telecommunications Engineering Technology - Cert. IV (41219)',
      short_name: '',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'ict50220',
      whole_name: 'Information Technology - Diploma (50220)',
      short_name: '',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'ict60220',
      whole_name: 'Information Technology - Adv. Diploma (60220)',
      short_name: '',
      type: ['ict'],
      tags: [],
    },
    {
      key: 'sit10116',
      whole_name: 'Tourism (Australian Indigenous Culture) - Cert. I (10116)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit10216',
      whole_name: 'Hospitality - Cert. I (10216)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit20116',
      whole_name: 'Tourism - Cert. II (20116)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit20216',
      whole_name: 'Holiday Parks and Resorts - Cert. II (20216)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit20316',
      whole_name: 'Hospitality - Cert. II (20316)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit20416',
      whole_name: 'Kitchen Operations - Cert. II (20416)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit20516',
      whole_name: 'Asian Cookery - Cert. II (20516)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit30116',
      whole_name: 'Tourism - Cert. III (30116)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit30216',
      whole_name: 'Travel - Cert. III (30216)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit30316',
      whole_name: 'Guiding - Cert. III (30316)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit30416',
      whole_name: 'Holiday Parks and Resorts - Cert. III (30416)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit30516',
      whole_name: 'Events - Cert. III (30516)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit30616',
      whole_name: 'Hospitality - Cert. III (30616)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit30716',
      whole_name: 'Hospitality - Cert. III (Restaurant Front of House) (30716)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit30816',
      whole_name: 'Commercial Cookery - Cert. III (30816)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit30916',
      whole_name: 'Catering Operations - Cert. III (30916)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit31016',
      whole_name: 'Patisserie - Cert. III (31016)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit31116',
      whole_name: 'Asian Cookery - Cert. III (31116)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit40116',
      whole_name: 'Travel and Tourism - Cert. IV (40116)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit40216',
      whole_name: 'Guiding - Cert. IV (40216)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit40316',
      whole_name: 'Holiday Parks and Resorts - Cert. IV (40316)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit40416',
      whole_name: 'Hospitality - Cert. IV (40416)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit40516',
      whole_name: 'Commercial Cookery - Cert. IV (40516)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit40616',
      whole_name: 'Catering Operations - Cert. IV (40616)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit40716',
      whole_name: 'Patisserie - Cert. IV (40716)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit40816',
      whole_name: 'Asian Cookery - Cert. IV (40816)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit50116',
      whole_name: 'Travel and Tourism Management - Diploma (50116)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit50216',
      whole_name: 'Holiday Parks and Resorts Management - Diploma (50216)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit50316',
      whole_name: 'Event Management - Diploma (50316)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit50416',
      whole_name: 'Hospitality Management - Diploma (50416)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit60116',
      whole_name: 'Travel and Tourism Management - Adv. Diploma (60116)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit60216',
      whole_name: 'Event Management - Adv. Diploma (60216)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'sit60316',
      whole_name: 'Hospitality Management - Adv. Diploma (60316)',
      short_name: '',
      type: ['sit'],
      tags: [],
    },
    {
      key: 'cua40320',
      whole_name: 'Dance Teaching and Management - Cert. IV (40320)',
      short_name: '',
      type: ['cua'],
      tags: [],
    },
    {
      key: 'hlt64115',
      whole_name: 'Nursing - Adv. Diploma (64115)',
      short_name: '',
      type: ['hlt'],
      tags: [],
    },
    {
      key: 'hlt54115',
      whole_name: 'Nursing - Diploma (54115)',
      short_name: '',
      type: ['hlt'],
      tags: [],
    },
    {
      key: 'hlt60113',
      whole_name:
        'Aboriginal and/or Torres Strait Islander Health Care - Adv. Diploma (60113)',
      short_name: '',
      type: ['hlt'],
      tags: [],
    },
    {
      key: 'hlt50113',
      whole_name:
        'Aboriginal and/or Torres Strait Islander Health Care - Diploma (50113)',
      short_name: '',
      type: ['hlt'],
      tags: [],
    },
    {
      key: 'hlt40113',
      whole_name:
        'Aboriginal and/or Torres Strait Islander Health Care - Cert. IV (40113)',
      short_name: '',
      type: ['hlt'],
      tags: [],
    },
    {
      key: 'hlt30113',
      whole_name:
        'Aboriginal and/or Torres Strait Islander Health Care - Cert. III (30113)',
      short_name: '',
      type: ['hlt'],
      tags: [],
    },
    {
      key: 'hlt20113',
      whole_name:
        'Aboriginal and/or Torres Strait Islander Health Care - Cert. II (20113)',
      short_name: '',
      type: ['hlt'],
      tags: [],
    },
    {
      key: 'hlt33215',
      whole_name: 'Health Support Services - Cert. III (33215)',
      short_name: '',
      type: ['hlt'],
      tags: [],
    },
    {
      key: 'hlt23215',
      whole_name: 'Health Support Services - Cert. II (23215)',
      short_name: '',
      type: ['hlt'],
      tags: [],
    },
    {
      key: 'hlt42015',
      whole_name: 'Massage Therapy - Cert. IV (42015)',
      short_name: '',
      type: ['hlt'],
      tags: [],
    },
    {
      key: 'hlt52015',
      whole_name: 'Remedial Massage - Diploma (52015)',
      short_name: '',
      type: ['hlt'],
      tags: [],
    },
    {
      key: 'tae40116',
      whole_name: 'Training and Assessment - Cert. IV (40116)',
      short_name: '',
      type: ['tae'],
      tags: [],
    },
    {
      key: 'tae50216',
      whole_name: 'Training Design and Development - Diploma (50216)',
      short_name: '',
      type: ['tae'],
      tags: [],
    },
    {
      key: 'tae50116',
      whole_name: 'Vocational Education and Training - Diploma (50116)',
      short_name: '',
      type: ['tae'],
      tags: [],
    },
    {
      key: 'sis30315',
      whole_name: 'Fitness - Cert. III',
      short_name: '',
      type: ['sis'],
      tags: [],
    },
    {
      key: 'sis40315',
      whole_name: 'Fitness - Cert. IV',
      short_name: '',
      type: ['sis'],
      tags: [],
    },
    {
      key: 'sis50315',
      whole_name: 'Fitness - Diploma',
      short_name: '',
      type: ['sis'],
      tags: [],
    },
    {
      key: 'cpp20218',
      whole_name: 'Security Operations - Cert. II (20218)',
      short_name: '',
      type: ['cpp'],
      tags: [],
    },
    {
      key: 'cpp31318',
      whole_name: 'Security Operations - Cert. III (31318)',
      short_name: '',
      type: ['cpp'],
      tags: [],
    },
    {
      key: 'cpp40719',
      whole_name: 'Security Management',
      short_name: '',
      type: ['cpp'],
      tags: [],
    },
    {
      key: 'py',
      whole_name: 'Professional Year',
      short_name: '',
      type: ['vet_other'],
      tags: [],
    },
  ];

  if (isCollege) {
    classes = classes.filter((cls) => {
      return (
        !!cls.type.find((type) => collegeCategories.includes(type)) &&
        !cls.tt_hide
      );
    });
  }

  return classes;
};

export const getBadges = () => {
  return [
    { badge_title: 'Adaptable', icon_path: './feedbackIcons/Adaptable.png' },
    {
      badge_title: 'Arrives Early',
      icon_path: './feedbackIcons/arrivesEarly.png',
    },
    { badge_title: 'Creative', icon_path: './feedbackIcons/Creative.png' },
    { badge_title: 'Energetic', icon_path: './feedbackIcons/Energetic.png' },
    {
      badge_title: 'Engages Students',
      icon_path: './feedbackIcons/engagesStudents.png',
    },
    { badge_title: 'Fun teacher', icon_path: './feedbackIcons/funTeacher.png' },
    {
      badge_title: 'Knows the field',
      icon_path: './feedbackIcons/knowsTheField.png',
    },
    { badge_title: 'On the ball', icon_path: './feedbackIcons/onTheBall.png' },
    { badge_title: 'Organised', icon_path: './feedbackIcons/Organised.png' },
    {
      badge_title: 'Quiet Achiever',
      icon_path: './feedbackIcons/quietAchiever.png',
    },
    { badge_title: 'Reliable', icon_path: './feedbackIcons/Reliable.png' },
    {
      badge_title: 'Resourceful',
      icon_path: './feedbackIcons/Resourceful.png',
    },
  ];
};

export const getRegions = () => {
  return [];
}

export const getCountries = () => {
  return [];
}

export const getCities = () => {
  return [];
}


export const getStates = () => {
  return ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'];
};

export const getDayOfWeek = (date) => {
  const dayOfWeek = new Date(date).getDay();
  return isNaN(dayOfWeek)
    ? null
    : [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ][dayOfWeek];
};

export const parseDate = (date) => {
  if (typeof date === 'string') {
    const d = date.split(/\D+/);
    return new Date(Date.UTC(d[0], --d[1], d[2], d[3], d[4], d[5], d[6]));
  } else return date;
};

export const parseTime = (timeString) => {
  if (timeString) {
    const timeArray = timeString.split(':');
    // console.log(timeString, timeArray)
    let hour = parseInt(timeArray[0]);
    let am_pm;
    if (hour >= 12) {
      if (hour > 12) hour -= 12;
      am_pm = 'PM';
    } else {
      if (hour === 0) hour = 12;
      am_pm = 'AM';
    }

    return `${hour}:${timeArray[1]} ${am_pm}`;
  }
};

const classList = getClass();

export const filterJobCriterias = (job) => {
  const arrayOfJobTags = Object.keys(job.tags);
  let kw = job.title + ' ' + arrayOfJobTags.join(' ');
  let loc = job.location;
  let cat = arrayOfJobTags
    .map((tag) => {
      let foundClass = classList.find((cl) => cl.whole_name === tag);
      if (foundClass) return foundClass.type.join(' ');
    })
    .join(' ');

  console.log(cat);

  return {
    keyword: kw.toLowerCase(),
    location: loc.toLowerCase(),
    category: cat.toLowerCase(),
  };
};

export const filterTeacherCriterias = (teacher) => {
  let kw = teacher.first_name + " " + teacher.last_name + " ";
  let cat = "";
  let loc = [teacher.preferred_online ? "Online" : false,
    teacher.preferred_city1, teacher.preferred_city2, teacher.preferred_city3].filter(Boolean).join(" ")

  if (teacher.can_delivers) {
    for (let category in teacher.can_delivers) {
      if (teacher.can_delivers[category].length && category !== "_id") {
        cat += category + " ";
        for (let cd of teacher.can_delivers[category]) {
          kw += cd + " ";
        }
      }
    }
  } else {
    teacher.can_deliver.forEach(c => {
      const category = classList.find(cls => cls.key === c.can_deliver)?.type?.[0]
      if (category && !(cat.includes(category))) {
        cat += category + " ";
      }
    })
  }

  return {
    keyword: kw.toLowerCase(),
    location: loc.toLowerCase(),
    category: cat.toLowerCase(),
  };
};

export const getTeacherProfileName = (user) => {
  if (user.first_name === 'None' && user.last_name === 'Available') {
    return 'None Available'
  }
  return (
    (user.preferred_name && user.preferred_name !== user.first_name
      ? user.first_name[0].toUpperCase() +
        user.first_name.slice(1) +
        ' (' +
        user.preferred_name[0].toUpperCase() +
        user.preferred_name.slice(1) +
        ') '
      : user.first_name[0].toUpperCase() + user.first_name.split(' ')[0].slice(1)) +
    ' ' +
    user.last_name[0].toUpperCase()
  );
};

export const getTeacherFullName = (user) => {
  if (user.first_name && user.last_name) {
    return (
      (user.preferred_name && user.preferred_name !== user.first_name
        ? user.first_name[0].toUpperCase() +
        user.first_name.slice(1) +
        ' (' +
        user.preferred_name[0].toUpperCase() +
        user.preferred_name.slice(1) +
        ') '
        : user.first_name[0].toUpperCase() + user.first_name.split(' ')[0].slice(1)) +
      ' ' +
      user.last_name[0].toUpperCase() + user.last_name.slice(1)
    );
  } else {
    return ""
  }
};

export const getTeacherType = (user) => {
  let type = '';
  if (user.is_vet) {
    if (user.is_elt) {
      type = 'English (ELT), Vocational (VET)/Digital & Tech Teacher';
    } else {
      type = 'Vocational (VET)/Digital & Tech Teacher';
    }
  } else if(user.is_childhood_teacher) {
    type = 'Early Childhood Educator';
  } else {
    type = 'English Language Teacher';
  }

  return type;
};

export const getTeacherState = (user) => {
  let user_state = "N.A."
  if (user.preferred_country1 && user.preferred_city1) {
    const states = State.getStatesOfCountry(user.preferred_country1)
    states.forEach(state => {
      const cities = City.getCitiesOfState(user.preferred_country1, state.isoCode)
      const city = cities.find(c => c.name === user.preferred_city1)
      if (city !== undefined) {
        user_state = state.isoCode
      }
    })
  }
  if (user_state === "N.A." && user.state) {
    return user.state
  }
  return user_state
}


export const dateToISO = (date) => {
  if (date) {
    let d = new Date(date - date.getTimezoneOffset() * 1000 * 60);
    d = d.toISOString().slice(0, 10); // YYYY-MM-DD
    return d;
  }
};

export const getValidStartDate = (job) => {
  return job.dates?.find(item => item.date >= job.booking_date)?.date
}

export const shortenStatesName = (state) => {
  switch (state.toUpperCase()) {
    case "VICTORIA":
      state = "VIC"
      break;
    case "QUEENSLAND":
      state = "QLD"
      break;
    case "AUSTRALIAN CAPITAL TERRITORY":
      state = "ACT"
      break;
    case "NEW SOUTH WALES":
      state = "NSW"
      break;
    case "NORTHERN TERRITORY":
      state = "NT"
      break;
    case "SOUTH AUSTRALIA":
      state = "SA"
      break;
    case "TASMANIA":
      state = "TA"
      break;
    case "WESTERN AUSTRALIA":
      state = "WA"
      break;
    default:
      state = state
      break;
  }
  return state
}

export const mapStateToCityForET = (state) => {
  let city = ""
  switch (state) {
    case "VIC":
      city = "Melbourne";
      break;
    case "NSW":
      city = "Sydney"
      break;
    case "ACT":
      city = "Canberra"
      break;
    case "SA":
      city = "Adelaide"
      break;
    case "QLD":
      city = "Brisbane"
      break;
    case "WA":
      city = "Perth"
      break;
    case "TA":
      city = "Hobart"
      break;
    case "NT":
      city = "Darwin"
      break;
    default:
      break;
  }
  return city
}

export const convertUrlWithQueryString = (url, params) => {
  const queryString = new URLSearchParams(params).toString();
  return queryString ? `${url}?` + queryString : `${url}`;
}


export const handleLogErrorToSlack = (error, isExternalUrl) => {
  try {
    const payload = {
      api_url: isExternalUrl ? error.config.url : convertUrlWithQueryString(PORT + error.config.url, error.config?.params || {}),
      web_url: window.location.href,
      method: error.config.method?.toUpperCase(),
      headers: error.config.headers,
      response: {
        status_code: error.response?.status,
        status_text: error.response?.statusText,
        data: error.response?.data
      },
      body: error.config?.data && JSON.parse(error.config?.data),
    }

    // handle request timeout
    if (error?.code === "ECONNABORTED") {
      payload.response.data = "Request to server timed out."
    }

    API.logErrorToSlack(payload)
      .catch((error) => {
        console.error("Log to slack error: ", error, isExternalUrl)
      })
  } catch (error) {
    console.error(`⚡️[log]: Get payload error: `, error, isExternalUrl);
  }
}
const getInitials = (name) => {
  let initials;
  const nameSplit = name.split(" ");
  const nameLength = nameSplit.length;
  if (nameLength > 1) {
      initials =
          nameSplit[0].substring(0, 1) +
          nameSplit[nameLength - 1].substring(0, 1);
  } else if (nameLength === 1) {
      initials = nameSplit[0].substring(0, 1);
  } else return;

  return initials.toUpperCase();
};

export const createImageFromInitials = (size, name, color) => {
  if (name == null) return;
  name=getInitials(name)

  const canvas=document.createElement('canvas')
  const context=canvas.getContext('2d')
  canvas.width=canvas.height=size

  context.fillStyle="#ffffff"
  context.fillRect(0,0,size,size)

  context.fillStyle=`${color}50`
  context.fillRect(0,0,size,size)

  context.fillStyle=color;
  context.textBaseline='middle'
  context.textAlign='center'
  context.font =`${size/2}px Roboto`
  context.fillText(name,(size/2),(size/2))

  return canvas.toDataURL()
};

export const statusInvoice = [
  {
      value: 1,
      name: 'Awaiting approval by manager'
  },
  {
      value: 2,
      name: 'Under review by RT admin'
  },
  {
      value: 3,
      name: 'Approved by customer'
  },
  {
      value: 4,
      name: 'Paid'
  }
];

export const sortDays = (days) => {
  const sortedDays = days.slice().sort((a, b) => {
    const order = { "Monday": 1, "Tuesday": 2, "Wednesday": 3, "Thursday": 4, "Friday": 5, "Saturday": 6, "Sunday": 7 }
    return order[a] - order[b]
  });

  return sortedDays
}

export const teacherLevel = {
  JUNIOR: 'junior',
  SENIOR: 'senior',
  CERT: 'cert',
  DIPLOMA: 'diploma',
  BACHELOR: 'bachelor',
  GOLD: 'gold',
  SILVER: 'silver',
  BRONZE: 'bronze',
  GRADUATE_DIPLOMA: 'graduate_diploma',
  EXPERT: 'expert',
  MASTER: 'master',
};

// Priority is: BACHELOR || GRADUATE_DIPLOMA > DIPLOMA > CERT
export const EcecDegree = {
  BACHELOR: "Bachelor of Early Childhood Education & Care",
  DIPLOMA: "Diploma of Early Childhood Education & Care",
  CERT: "Cert. III in Early Childhood",
  GRADUATE_DIPLOMA: "Graduate Diploma in Early Childhood Education"
}

export const TeacherEltRate = {
  junior: 63.25,
  senior: 69.06,
  expert: 74.70,
  master: 78.57
};

export const TeacherEltRate2025 = {
  junior: 66.25,
  senior: 72.34,
  expert: 78.25,
  master: 82.30
};

export const getTeacherEltRateByTeacherLevel = (level, is2025 = false) => {
  const rate = is2025 ? TeacherEltRate2025 : TeacherEltRate
  switch (level) {
    case teacherLevel.JUNIOR:
      return `Junior/Online $${rate?.[teacherLevel.JUNIOR]}`;

    case teacherLevel.SENIOR:
      return `Senior $${rate?.[teacherLevel.SENIOR]}`;

    case teacherLevel.EXPERT:
      return `Expert $${rate?.[teacherLevel.EXPERT]}`;

    case teacherLevel.MASTER:
      return `Master $${rate?.[teacherLevel.MASTER]}`;

    default:
      return 0;
  }
};

export const CustomerEltRate = {
  junior: 69.58,
  senior: 75.97,
  expert: 82.17,
  master: 86.43
};

export const CustomerEltRate2025 = {
  junior: 72.88,
  senior: 79.57,
  expert: 86.07,
  master: 90.53
};

export const getCustomerEltRateByTeacherLevel = (level, is2025 = false) => {
  const rate = is2025 ? CustomerEltRate2025 : CustomerEltRate
  switch (level) {
    case teacherLevel.JUNIOR:
      return `Junior/Online $${rate?.[teacherLevel.JUNIOR]}`;

    case teacherLevel.SENIOR:
      return `Senior $${rate?.[teacherLevel.SENIOR]}`;

    case teacherLevel.EXPERT:
      return `Expert $${rate?.[teacherLevel.EXPERT]}`;

    case teacherLevel.MASTER:
      return `Master $${rate?.[teacherLevel.MASTER]}`;

    default:
      return 0;
  }
};

// get qualification type for booking card (including: teacher, customer, personnel)
export const getQualificationTypeForBooking = (qualifications, classLevelId) => {
  for (const qualification of qualifications) {
    const qualificationType = qualification?.type

    for (const qua of qualification?.qualifications) {
      if (['elt', 'ecec'].includes(qualificationType) && qua._id === classLevelId) {
        return qualificationType
      } else if (qualificationType === 'vet') {
        for (const unit of qua?.units) {
          if (unit._id === classLevelId) {
            return qualificationType
          }
        }
      }
    }
  }

  return null
}

export const GOOGLE_MAP_API_KEY = "AIzaSyDxh8ToQpHORvn-VVLhwO5RDdPijurBcBw"

// Pay Level
export const TEACHING_QUAL_AUSTRALIA_WITH_EXP = "I completed my teaching qualification and I have taught at an Australian company that is NOT ReadyTeacher";
export const TEACHING_QUAL_AUSTRALIA_NO_EXP = "I completed my teaching qualification in Australia and have no experience teaching English to adult learners";
export const TEACHING_QUAL_OVERSEAS_WITH_EXP = "I completed my teaching qualification in Australia OR overseas and I have overseas work experience only";
export const TEACHING_QUAL_OVERSEAS_NO_EXP = "I completed my teaching qualification outside Australia and have no experience teaching English to adult learners";

export const LIST_PAY_LEVEL_EVIDENCES = [
  TEACHING_QUAL_AUSTRALIA_WITH_EXP,
  TEACHING_QUAL_AUSTRALIA_NO_EXP,
  TEACHING_QUAL_OVERSEAS_WITH_EXP,
  TEACHING_QUAL_OVERSEAS_NO_EXP,
]

export const getPresumedLevelName = (presumedLevelNumber) => {
  if (presumedLevelNumber === 0) return "Unknown";
  if ([3, 4].includes(presumedLevelNumber)) return "Junior";
  if (presumedLevelNumber >= 5 && presumedLevelNumber <= 7) return "Senior";
  if (presumedLevelNumber >= 8 && presumedLevelNumber <= 10) return "Expert";
  if (presumedLevelNumber >= 11 && presumedLevelNumber <= 12) return "Master";

  return "";
};

export const PAY_LEVEL_STATUS = {
  UPLOADED: 'uploaded',
  REJECTED: 'rejected',
  ACCEPTED: 'accepted',
}

export const LIST_PAY_LEVEL_STATUS = [
  PAY_LEVEL_STATUS.UPLOADED,
  PAY_LEVEL_STATUS.REJECTED,
  PAY_LEVEL_STATUS.ACCEPTED,
]

export const showPayLevelStatus = (status) => {
  switch(status) {
    case PAY_LEVEL_STATUS.UPLOADED:
      return 'Not assessed';
    case PAY_LEVEL_STATUS.REJECTED:
      return 'Rejected';
    case PAY_LEVEL_STATUS.ACCEPTED:
      return 'Approved';
    default:
      return 'Not uploaded';
  }
}

export const levelOptions = [
  {
    value: 3,
    rate: 59.94,
  },
  {
    value: 4,
    rate: 61.11,
  },
  {
    value: 5,
    rate: 63.58,
  },
  {
    value: 6,
    rate: 65.23,
  },
  {
    value: 7,
    rate: 66.73,
  },
  {
    value: 8,
    rate: 68.38,
  },
  {
    value: 9,
    rate: 70.03,
  },
  {
    value: 10,
    rate: 72.17,
  },
  {
    value: 11,
    rate: 74.16,
  },
  {
    value: 12,
    rate: 75.92,
  },
  {
    value: 0,
    rate: 0,
  }
];
